<script lang="ts">
  import { onMount } from "svelte";
  import { initList, records, filter, search } from "./score.store";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { formatDateHuman } from "../../utils/date-utils";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import ClassroomDropdown from "../../components/Business/ClassroomDropdown.svelte";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="student"
    entityPlural="students"
    numRecords={0}
    numRecordsVisible={false}
    searchFieldVisible={false}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="classroom-search-box">
      <div style="min-width: 25rem;">
        <ClassroomDropdown
          name=""
          placeholder="classroom"
          required={false}
          clearVisible={true}
          bind:value={$filter.criteria.classroomId}
          on:select={search}
          on:clear={search}
        />
      </div>
    </div>
  </SearchHeader>

  <div class="content box">
    <h2 class="subtitle">Hall of Fame</h2>

    <table class="scores-table">
      <tr>
        <th>User</th>
        <th>Classroom</th>
        <th>Score</th>
        <th>Latest submission</th>
      </tr>
      {#if $records}
        {#each $records as item}
          <tr>
            <td>{item.lastName} {item.firstName}</td>
            <td>{item.classroomName}</td>
            <td>{item.score}</td>
            <td>{item.lastSubmissionDate ? formatDateHuman(item.lastSubmissionDate) : "N/A"}</td>
          </tr>
        {/each}
        {#if $records.length == 0}
          <tr>
            <td colspan="4" class="has-text-centered">no data available</td>
          </tr>
        {/if}
      {/if}
    </table>
  </div>
</MainLayout>

<style>
  .classroom-search-box {
    display: flex;
    flex-direction: row;
  }
  .classroom-search-box div {
    padding-right: 0.75rem;
  }

  .scores-table {
    border: 1px solid #ccc;
  }
</style>
